import { render, staticRenderFns } from "./ActionAllowedContents.vue?vue&type=template&id=49526749"
import script from "./ActionAllowedContents.vue?vue&type=script&lang=js"
export * from "./ActionAllowedContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports